<style lang="scss" scoped>
.table-header {
  border: 1px solid #ebeef5;
  border-bottom: none;
  height: 50px;
}
.refresh {
  background-color: #f5f5f5;
  width: 50px;
  &:hover .icon_refresh {
    color: rgba(0, 0, 0, 0.6);
  }
}
.icon_refresh {
  color: #999;
  line-height: 50px;
}
.operation {
  white-space: nowrap;
}
</style>
<template>
  <div class="account height_100 flex_tb">
    <!-- 條件刪選 -->
    <collapse @seach="state.seach" />
    <div class="width_100 table-header sizing flex_lr_m">
      <div>
        <i class="el-icon-s-grid pad20" style="color: #999"></i>
        <el-button type="primary" size="mini" @click="addAttribute"
          >新增屬性</el-button
        >
        <el-button
          type="danger"
          size="mini"
          :disabled="!state.delAccountId.length"
          @click="dels_confirm"
          >批量刪除</el-button
        >
      </div>
      <div class="refresh sizing height_100 flex_c_m" @click="refresh">
        <i class="el-icon-refresh cursor fonts-22 icon_refresh"></i>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      :data="state.tableData"
      height="100%"
      border
      style="width: 100%"
      class="flex1"
      :row-class-name="tableRowClassName"
      @selection-change="selection_change"
    >
      <!-- <el-table-column prop="id" label="id" sortable> </el-table-column> -->
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="attr_values_name" label="昵稱" min-width="80">
      </el-table-column>
      <el-table-column prop="attr_values_stock" label="庫存" min-width="80">
      </el-table-column>
      <el-table-column prop="stores" label="所屬門店" min-width="80">
      </el-table-column>
      <el-table-column prop="created_at" label="創建時間" min-width="80">
      </el-table-column>
      <el-table-column prop="updated_at" label="修改時間" min-width="80">
      </el-table-column>
      <el-table-column prop="status" label="狀態">
        <template #default="scope">
          <span>{{ scope.row.status ? "正常" : "禁用" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="member_name"
        label="操作"
        min-width="180px"
        fixed="right"
      >
        <template #default="scope">
          <div class="operation height_100 flex_c_m" style="flex-wrap: wrap">
            <el-button type="primary" size="mini" @click="lookInfo(scope.row)"
              >編輯</el-button
            >
            <el-button type="danger" size="mini" @click="deleteInfo(scope.row)"
              >刪除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分頁 -->
    <div class="flex_m_r pain pad20">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="state.user.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="Number(state.count)"
      >
      </el-pagination>
    </div>
    <!-- 彈窗 -->
    <pop-up
      :dialogVisible="state.dialogVisible"
      :userId="'' + state.userId"
      @toggleDialogVisible="toggleDialogVisible"
      @reloadData="reloadData"
      :form="state.form"
      :isEdit="state.isEdit"
    />
    <!-- 提示框 -->
    <el-dialog title="提示" v-model="state.dialog" width="400px">
      <span>確定刪除嗎？</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="state.dialog = false">取 消</el-button>
          <el-button type="primary" @click="dels_confirm">確 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, getCurrentInstance } from "vue";
import Collapse from "./components/collapse";
import PopUp from "./components/pop-up";

export default {
  components: {
    Collapse,
    PopUp,
  },
  setup() {
    const req_table_data = () => {
      $http.getGoodsAttrValues(state.user).then((res) => {
        if (res.status !== 200) return;
        state.tableData = res.data.data;
        state.count = res.data.count;
      });
    };

    var state = reactive({
      tableData: [], // 表格数据
      user: {
        // 请求参数
        limit: 10,
        page: 1,
        attr_values_name: "",
        status: "",
      },
      count: "", // 總條數
      seach(data) {
        // 查询里面的数据
        state.user.attr_values_name = data.seatch_name;
        state.user.status = data.region;
        req_table_data();
      },
      dialogVisible: false, // 弹窗开关
      dialog: false, // 提示框开关
      delAccountId: [], // 批量刪除的id
      delUserId: [], // 单个删除的id
      userId: "", // 用户id
      form: {
        // 表单数据
        name: "", // 名稱
        region: "1", // 狀態
        classify: "", // 门店
        inventory: 0, // 庫存
      },
      isEdit: false,
    });

    const proxy = getCurrentInstance().appContext.config.globalProperties;
    const { $http, $message } = proxy;

    // init
    req_table_data();

    // 分頁組件改變页数
    const handleCurrentChange = (val) => {
      state.user.page = val;
      req_table_data();
    };

    // 分頁組件改變每頁顯示条数
    const handleSizeChange = (val) => {
      state.user.limit = val;
      req_table_data();
    };

    // 刷新
    const refresh = () => {
      req_table_data();
    };

    // 弹出层的显示开关
    const toggleDialogVisible = () => {
      state.dialogVisible = false;
    };

    // 弹出层点击确定触发
    const reloadData = async (data) => {
      if (!state.isEdit) {
        const res = await $http.addGoodsAttrValues({
          attr_values_name: data.name,
          stores: data.classify,
          attr_values_stock: data.inventory,
          status: data.region,
        });
        if (res.status !== 200) return;
        $message.success("新增成功");
      } else {
        const res = await $http.editGoodsAttrValues({
          id: state.form.id,
          stores: state.form.classify,
          attr_values_stock: state.form.inventory,
          attr_values_name: state.form.name,
          status: state.form.region,
        });
        if (res.status !== 200) return;
        $message.success("修改成功");
      }

      req_table_data();
    };

    // 选中的id数组
    const selection_change = (selection) => {
      state.delAccountId = selection.map((item) => {
        item = item.id;
        return item;
      });
    };

    // 选中的id数组
    const del_accout = () => {
      state.delUserId = [];
      state.dialog = true;
    };

    // 确定弹出层点击确定
    const dels_confirm = async () => {
      const res = await $http.delGoodsAttrValues({
        id:
          state.delAccountId.length !== 0
            ? state.delAccountId
            : state.delUserId,
      });
      if (res.status !== 200) return;
      $message.success("刪除成功");
      req_table_data();
      state.dialog = false;
    };

    // 刪除用戶
    const deleteInfo = (data) => {
      console.log(data);
      state.delUserId = [data.id];
      state.dialog = true;
    };

    // 編輯屬性
    const lookInfo = (data) => {
      state.isEdit = true;
      state.form = {
        // 表单数据
        name: data.attr_values_name, // 名稱
        region: "" + data.status, // 狀態
        classify: data.stores, // 门店
        inventory: data.attr_values_stock, // 庫存
        id: data.id,
      };
      state.dialogVisible = true;
    };

    // 新增屬性
    const addAttribute = () => {
      state.dialogVisible = true;
      state.isEdit = false;
      state.form = {
        // 表单数据
        name: "", // 名稱
        region: "1", // 狀態
        classify: "", // 门店
        inventory: 0, // 庫存
      };
    };

    const tableRowClassName = ({ row }) => {
      if (row.is_min_stock) {
        return "warning-row";
      }
      return "";
    };

    return {
      state,
      handleCurrentChange,
      handleSizeChange,
      refresh,
      toggleDialogVisible,
      reloadData,
      selection_change,
      del_accout,
      dels_confirm,
      deleteInfo,
      lookInfo,
      addAttribute,
      tableRowClassName,
    };
  },
};
</script>
